import React from 'react';
import { withSitecoreContext } from '@sitecore-jss/sitecore-jss-react';
import { withNamespaces } from 'react-i18next';
import isEmpty from 'lodash/isEmpty';
import withErrorBoundary from '../../../utils/HOCs/withErrorBoundary';
import Grid from '../../../components/molecules/Grid';
import Tabs from '../../../components/molecules/Tabs';
import RichText from '../../../components/atoms/RichText';
// import fields from './__test__/mockData';
import { COMPONENT_NAME } from './locators';
import useStyles from './style';
import { DetailedDescription } from '../DetailedDescription';
import EventPartners from '../../../components/organism/EventPartners';
import { eventPartnersPreprocessData } from './eventPartnersPreprocessData';
import { getDictionaryText } from '../../../utils/getDictionaryText';
import { getPageTitle } from '../../../utils/getPageTitle';
import { getUId } from '../../../../utils/utility';

const EventDetails = props => {
  const fields = props.fields;
  const classes = useStyles({});
  const uid = getUId(props)
  let getEventsListingPreprocessedData = '';
  const createTabs =
    fields.eventDetails &&
    fields.eventDetails.map(tab => {
      const tabClassName =
        tab &&
        tab.uniqueKey &&
        tab.uniqueKey
          .toLowerCase()
          .split('.')
          .join('-');
      return {
        data: <RichText innerHTML={tab} className={tabClassName} />,
        label: tab.key,
      };
    });

  if (fields && fields.eventListing && fields.eventListing.length > 0) {
    getEventsListingPreprocessedData = eventPartnersPreprocessData(
      fields.eventListing
    );
    // createTabs.unshift({
    //   data: <EventPartners data={getEventsListingPreprocessedData} />,
    //   label: getDictionaryText('eventListing'),
    // });
  }

  createTabs && createTabs.unshift({
    data: (
      <div className="descriptionEventWrapper">
        <DetailedDescription {...props} />
      </div>
    ),
    label: getDictionaryText('eventOverview'),
  });

  let title = `${getPageTitle(props.sitecoreContext)} ${getDictionaryText(
    'eventListing'
  )}`; //#TODO to fix after discussion with Sitecore

  return fields && fields.isUmbrellaEvent ? (
    <div className={classes.wrapper} data-locator={COMPONENT_NAME} uid={uid}>
      <Grid>
        <Tabs tabs={createTabs} className="tabs-container" />
        <EventPartners data={getEventsListingPreprocessedData} title={title} />
      </Grid>
    </div>
  ) : (
    <DetailedDescription {...props} />
  );
};

export default withErrorBoundary(
  withSitecoreContext()(withNamespaces()(EventDetails))
);
